/* eslint-disable no-magic-numbers */
import ICountUp from "vue-countup-v2";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	props: {
		value: { type: [Number, String] },
		type: {
			/*
			 * type can be:
			 * - kg-left - prints unit left of the number
			 * - gr - prints minor unit name to the right
			 * - gr-hidden - treats value as grams, but does not print units
			 * - kg - prints (major) unit name to the right
			 * - kg-hidden - treats value as kilograms, but does not print units (default)
			 */
			type: String,
			validator: function (value) {
				return ["kg-left", "gr", "gr-hidden", "kg", "kg-hidden"].includes(value);
			},
		},
		inline: {
			type: Boolean,
			default: false,
		},
		showLess: {
			type: Boolean,
			default: false,
		},
		digits: {
			type: String,
			default: "0",
		},
		grouping: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return { endVal: 0 };
	},

	computed: {
		scale() {
			return this.type === "gr" || this.type === "gr-hidden" ? this.weightFactorMinor : this.weightFactor;
		},

		isBetweenZeroAndOne() {
			return !this.getDigits() && this.value * this.scale > 0 && this.value * this.scale < 1;
		},

		...userGetters(["activeOutlet", "weightUnit", "weightUnitMinor", "weightFactor", "weightFactorMinor"]),

		options() {
			return {
				useEasing: true,
				useGrouping: this.grouping,
				separator: ",",
				decimal: ".",
				prefix: "",
				suffix: "",
				duration: 0.5,
				decimalPlaces: this.getDigits(),
			};
		},
	},

	beforeMount() {
		if (this.getDigits()) this.initEndVal();
		else if (this.isBetweenZeroAndOne) this.endVal = "<1";
		else this.initEndVal();
	},

	created() {
		/* eslint-disable no-unused-vars */
		this.$store.watch(
			(state) => this.$store.getters["user/weightUnit"],
			(value) => this.handleValueChange()
			// { deep: true }
		);
	},

	watch: {
		value: {
			handler: function () {
				this.handleValueChange();
			},
			deep: true,
		},
	},

	components: { ICountUp },

	methods: {
		onReady: function (instance) {
			if (this.endVal !== this.endVal) instance.update(0 + this.endVal);
		},
		computeEndValWithDigits() {
			if (this.value) return Number((Number(this.value) * this.scale).toFixed(this.getDigits()));

			return 0;
		},
		initEndVal() {
			this.endVal = this.computeEndValWithDigits();
		},
		handleValueChange() {
			if (this.getDigits()) this.initEndVal();
			else if (this.isBetweenZeroAndOne) this.endVal = "<1";
			else {
				this.endVal = 0;
				this.$nextTick(() => {
					this.initEndVal();
				});
			}
		},
		getDigits: function () {
			const digits = Number(this.digits);

			// for ounces (oz) we want to use 1 decimal, grams rounded to whole number...
			if (!digits) return ["gr", "gr-hidden"].includes(this.type) && this.weightUnitMinor !== "gr" ? 1 : 0;

			return digits;
		},
	},
};
